<div class="row">
    <label class="col-md-3 col-form-label text-md-right">{{labelText}}
        <ng-container *ngIf="isRequired">
            <span class="star">*</span>
        </ng-container>
    </label>
    <div class="col-md-9" style="align-content: center;">

            <ng-content></ng-content>

    </div>
</div>